import qs from 'qs';

import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';

const getAll = (page) =>
  request({
    url: API.AVVISO,
    method: 'GET',
    params: { page },
  });

const getMessagesWithSearch = (page, { message, gravita }, orderField, orderDirection) =>
  request({
    url: API.AVVISO,
    method: 'GET',
    params: {
      page: page || 1,
      filter: [
        message && {
          type: 'like',
          field: 'messaggio',
          value: `%${message}%`,
        },
        gravita && {
          type: 'eq',
          field: 'gravita',
          value: gravita,
        },
      ].filter(Boolean),
      'order-by': [
        {
          type: 'field',
          field: orderField || 'updatedAt',
          direction: orderDirection || 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getActiveMessage = () =>
  request({
    url: API.AVVISO,
    method: 'GET',
    params: {
      filter: [
        {
          type: 'eq',
          field: 'attivo',
          value: 1,
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const create = (content) =>
  request({
    url: API.AVVISO,
    method: 'POST',
    data: content,
  });

const put = (content) =>
  request({
    url: `${API.AVVISO}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const delAvviso = (id) =>
  request({
    url: `${API.AVVISO}/${id}`,
    method: 'DELETE',
  });

const AvvisoService = {
  getAll,
  create,
  put,
  delAvviso,
  getActiveMessage,
  getMessagesWithSearch,
};

export default AvvisoService;



// WEBPACK FOOTER //
// ./app/shared/services/api/internokiron/avviso/index.js